var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBCheckDouble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-check-double",
    x: 0.001,
    y: 0.001,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-check-double1",
    serifid: "iconB-check-double"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.262,14.05c0.001,0.002 0.002,0.003 0.003,0.004l5.867,5.87c0.03,0.029 0.07,0.046 0.112,0.046c0.041,-0 0.081,-0.017 0.111,-0.046l11.403,-11.328c0.4,-0.395 1.051,-0.396 1.412,-0.001c0.431,0.397 0.441,1.043 0.011,1.402c-0.004,0.003 -0.007,0.006 -0.011,0.01l-12.243,12.162c-0.003,0.004 -0.006,0.007 -0.01,0.011c-0.358,0.43 -0.997,0.425 -1.394,-0.003c-0.062,-0.061 -5.457,-5.458 -6.541,-6.542l-0.187,-0.187l-0.001,-0.001c-0.395,-0.362 -0.388,-1.005 0.009,-1.403c0.399,-0.396 1.043,-0.399 1.445,-0.008c0.003,0.003 0.009,0.009 0.009,0.009c0.002,0.002 0.003,0.004 0.005,0.005Zm2.738,-8.32l0.016,0.006c0.045,0.019 0.064,0.048 0.069,0.078l3.047,3.051c0.03,0.029 0.07,0.046 0.112,0.046c0.041,-0 0.081,-0.017 0.111,-0.046l7.06,-7.064c0.399,-0.398 1.045,-0.403 1.406,-0.005c0.003,0.003 0.007,0.007 0.01,0.01c0.433,0.398 0.434,1.042 0.003,1.441l-7.906,7.863c-0.001,0.001 -0.007,0.007 -0.011,0.011c-0.358,0.43 -0.997,0.425 -1.394,-0.003c-0.047,-0.047 -3.216,-3.217 -3.854,-3.855l-0.11,-0.11c-0.395,-0.362 -0.388,-1.005 0.008,-1.403c0.395,-0.391 1.031,-0.398 1.433,-0.02Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBCheckDouble);
export default __webpack_public_path__ + "static/media/iconB-check-double.66fcc97caaf0ab11677b00c3308bc6d0.svg";
export { ForwardRef as ReactComponent };